import { render } from "./ShopCard.vue?vue&type=template&id=f9cab528"
import script from "./ShopCard.vue?vue&type=script&lang=js"
export * from "./ShopCard.vue?vue&type=script&lang=js"

import "./ShopCard.vue?vue&type=style&index=0&id=f9cab528&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__